import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentLibrary } from '@apps/documents/document.state';
import { Store } from '@ngrx/store';
import { go } from '@platform/router.actions';
import { RootState } from '@root/app.state';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private router: Router,
    private store$: Store<RootState>,
  ) {}

  navigateCreateProject(customerSpaceId: string) {
    this.router.navigate(['/', 'customer-spaces', customerSpaceId, 'projects', 'create']);
  }

  navigateCreateTask(customerSpaceId: string) {
    this.router.navigate(['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'tasks', 'create']);
  }

  navigateToDocuments(library: DocumentLibrary, customerSpaceId: string) {
    this.store$.dispatch(go({ path: ['customer-spaces', customerSpaceId, 'documents', library.title, library.name] }));
  }

  navigateCreateLibrary(customerSpaceId: string) {
    this.router.navigate(['/', 'customer-spaces', customerSpaceId, 'documents', 'libraries', 'create']);
  }

  navigateTaskDetail(customerSpaceId: string, taskId: string) {
    this.router.navigate(['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'tasks', taskId]);
  }
}
